import { type ActionSpell } from './ActionsSection';

/**
 * Tooltip text for a spell pill (#246). Prefers the spell's enriched summary;
 * falls back to "name · Cantrip/Level N" so the overlay is never blank (a
 * missing per-character `spell_mechanics` summary previously rendered no tooltip
 * at all). `override` forces specific text, e.g. "Out of slots".
 *
 * Lives in this non-component module (not ActionSpell's `ActionsSection.tsx`) so
 * the component file exports only components — keeps React Fast Refresh working.
 */
export function spellTooltipText(spell: ActionSpell, override?: string): string {
  return (
    override ??
    spell.summary ??
    `${spell.name} · ${spell.isCantrip ? 'Cantrip' : `Level ${spell.level}`}`
  );
}
